export default [{
  path: 'classify/recommend',
  name: 'recommend',
  meta: {
    index: 12
  },
  component: () => import('@/views/classify/recommend.vue')
}]
